import { css } from "@emotion/react";
import { media } from "styles/breakpoints";

export const LoadingMatchStyle = {
  wrapper: css`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 2;

    .shimmer-block {
      position: relative;
      overflow: hidden;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.14);
    }

    .shimmer-block::after {
      content: "";
      position: absolute;
      inset: 0;
      transform: translateX(-100%);
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.24) 50%,
        transparent 100%
      );
      animation: match-schedule-shimmer 1.6s infinite;
    }

    .loading-league {
      width: 68%;
      height: 36px;
      margin: 10px auto 0;
    }

    .loading-time {
      width: 56%;
      height: 44px;
      margin: 20px auto 0;
    }

    .match-hero.is-loading {
      margin-top: 32px;
    }

    .loading-odds {
      width: 56px;
      height: 22px;
    }

    .loading-team-name {
      width: 90px;
      height: 22px;
      margin-top: 10px;
    }

    .loading-team-side {
      width: 60px;
      height: 18px;
    }

    .loading-versus {
      opacity: 0.45;
    }

    .loading-action {
      width: 140px;
      height: 60px;
      border-radius: 999px;
    }

    .loading-market {
      width: 84px;
      height: 18px;
    }

    @keyframes match-schedule-shimmer {
      100% {
        transform: translateX(100%);
      }
    }

    ${media.lg} {
      .loading-league {
        height: 32px;
      }

      .loading-time {
        height: 40px;
      }
    }

    ${media.md} {
      .loading-league {
        height: 28px;
      }

      .loading-time {
        height: 34px;
      }

      .loading-action {
        width: 120px;
        height: 50px;
      }
    }

    ${media.sm} {
      .loading-time {
        width: 72%;
        height: 28px;
      }

      .loading-team-name {
        width: 70px;
        height: 18px;
      }

      .loading-team-side {
        width: 48px;
        height: 14px;
      }

      .loading-action {
        width: 108px;
        height: 44px;
      }
    }
  `,
};
